module.exports = __webpack_public_path__ + "media/vendor/feather/fonts/feather-129f222de86b267622a584d798b0eed7.svg";